import { useState } from "react";
import CreateAssistant from "./CreateAssistant";
import EditAssistant from "./EditAssistant";

const AssistantManagement = () => {
  const [activeTab, setActiveTab] = useState<"create" | "edit">("create");

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">إدارة المدرسين المساعدين</h2>

      {/* Tabs */}
      <div className="flex gap-2 mb-4 border-b">
        <button
          type="button"
          className={`px-4 py-2 font-semibold transition-colors hover:cursor-pointer ${
            activeTab === "create"
              ? "border-b-2 border-primary text-primary"
              : "text-gray-500 hover:text-gray-700"
          }`}
          onClick={() => setActiveTab("create")}
        >
          إنشاء مدرس مساعد جديد
        </button>
        <button
          type="button"
          className={`px-4 py-2 font-semibold transition-colors hover:cursor-pointer ${
            activeTab === "edit"
              ? "border-b-2 border-primary text-primary"
              : "text-gray-500 hover:text-gray-700"
          }`}
          onClick={() => setActiveTab("edit")}
        >
          تعديل مدرس مساعد
        </button>
      </div>

      {/* Tab Content */}
      <div className="mt-4">
        {activeTab === "create" ? <CreateAssistant /> : <EditAssistant />}
      </div>
    </div>
  );
};

export default AssistantManagement;
